// extracted by mini-css-extract-plugin
export default {"spinner":"styles_spinner__UUSch","spin":"styles_spin__v0TOf"};